/* ============================================
   FLAVOR THEME — Full Animation Suite
   Matches Sport's Point Homepage HTML exactly
   ============================================ */

(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* -----------------------------------------------
     SCROLL PROGRESS BAR
  ----------------------------------------------- */
  var prog = document.getElementById('prog');
  if (prog) {
    window.addEventListener('scroll', function () {
      var total = document.body.scrollHeight - window.innerHeight;
      if (total > 0) prog.style.width = (window.scrollY / total * 100) + '%';
    }, { passive: true });
  }

  /* -----------------------------------------------
     CANVAS PARTICLES (hero)
  ----------------------------------------------- */
  var heroCanvas = document.querySelector('canvas[id^="hero-cv"]');
  if (heroCanvas && !prefersReduced) {
    var cx = heroCanvas.getContext('2d');
    var W, H, pts = [];
    var N = 60, CONN = 120;
    var mouse = { x: -999, y: -999 };

    function resizeCanvas() {
      W = heroCanvas.width = heroCanvas.offsetWidth;
      H = heroCanvas.height = heroCanvas.offsetHeight;
    }
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    for (var i = 0; i < N; i++) {
      pts.push({
        x: Math.random() * 1920, y: Math.random() * 900,
        vx: (Math.random() - .5) * .45, vy: (Math.random() - .5) * .45,
        r: Math.random() * 1.8 + .4, a: Math.random() * .7 + .2
      });
    }

    heroCanvas.addEventListener('mousemove', function (e) {
      var r = heroCanvas.getBoundingClientRect();
      mouse.x = e.clientX - r.left;
      mouse.y = e.clientY - r.top;
    });
    heroCanvas.addEventListener('mouseleave', function () { mouse.x = mouse.y = -999; });

    function drawParticles() {
      cx.clearRect(0, 0, W, H);
      for (var i = 0; i < N; i++) {
        var p = pts[i];
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0 || p.x > W) p.vx *= -1;
        if (p.y < 0 || p.y > H) p.vy *= -1;
        var dx = p.x - mouse.x, dy = p.y - mouse.y;
        var md = Math.sqrt(dx * dx + dy * dy);
        if (md < 100) { p.x += dx / md * 1.8; p.y += dy / md * 1.8; }
        cx.beginPath(); cx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        cx.fillStyle = 'rgba(255,255,255,' + (p.a * .55) + ')'; cx.fill();
        for (var j = i + 1; j < N; j++) {
          var q = pts[j], dx2 = p.x - q.x, dy2 = p.y - q.y;
          var d2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
          if (d2 < CONN) {
            cx.beginPath(); cx.moveTo(p.x, p.y); cx.lineTo(q.x, q.y);
            cx.strokeStyle = 'rgba(255,255,255,' + ((1 - d2 / CONN) * .13) + ')';
            cx.lineWidth = .5; cx.stroke();
          }
        }
      }
      requestAnimationFrame(drawParticles);
    }
    drawParticles();
  }

  /* -----------------------------------------------
     COUNT-UP STATS
  ----------------------------------------------- */
  var cntEls = document.querySelectorAll('.cnt[data-to]');
  if (cntEls.length) {
    var cntObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        var target = parseFloat(el.dataset.to);
        var dur = parseInt(el.dataset.dur) || 1600;
        var s0 = performance.now();
        (function step(now) {
          var t = Math.min((now - s0) / dur, 1);
          var e = 1 - Math.pow(1 - t, 3);
          el.textContent = Math.round(e * target);
          if (t < 1) requestAnimationFrame(step);
        })(s0);
        cntObs.unobserve(el);
      });
    }, { threshold: .6 });
    cntEls.forEach(function (c) { cntObs.observe(c); });
  }

  /* -----------------------------------------------
     3D TILT — category cards [data-tilt]
  ----------------------------------------------- */
  document.querySelectorAll('[data-tilt]').forEach(function (el) {
    el.addEventListener('mousemove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - .5;
      var y = (e.clientY - r.top) / r.height - .5;
      el.style.transform = 'perspective(900px) rotateY(' + (x * 14) + 'deg) rotateX(' + (-y * 10) + 'deg) scale(1.02)';
      el.style.transition = 'transform .08s';
    });
    el.addEventListener('mouseleave', function () {
      el.style.transform = '';
      el.style.transition = 'transform .55s cubic-bezier(.34,1.56,.64,1)';
    });
  });

  /* -----------------------------------------------
     3D TILT — product cards [data-tcard]
  ----------------------------------------------- */
  document.querySelectorAll('[data-tcard]').forEach(function (el) {
    el.addEventListener('mousemove', function (e) {
      var r = el.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - .5;
      var y = (e.clientY - r.top) / r.height - .5;
      el.style.transform = 'perspective(800px) rotateY(' + (x * 9) + 'deg) rotateX(' + (-y * 7) + 'deg) scale(1.02)';
      el.style.transition = 'transform .08s';
    });
    el.addEventListener('mouseleave', function () {
      el.style.transform = '';
      el.style.transition = 'transform .55s cubic-bezier(.34,1.56,.64,1)';
    });
  });

  /* -----------------------------------------------
     MAGNETIC BUTTONS .btn-r
  ----------------------------------------------- */
  document.querySelectorAll('.btn-r').forEach(function (btn) {
    btn.addEventListener('mousemove', function (e) {
      var r = btn.getBoundingClientRect();
      var x = (e.clientX - r.left - r.width / 2) * .22;
      var y = (e.clientY - r.top - r.height / 2) * .22;
      btn.style.transform = 'translate(' + x + 'px,' + y + 'px) translateY(-3px)';
    });
    btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
  });

  /* -----------------------------------------------
     CSS FALLBACK — show elements if no GSAP
  ----------------------------------------------- */
  if (prefersReduced || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    document.querySelectorAll('.rv,.rvl,.rvr,.rvs').forEach(function (el) {
      el.style.opacity = '1'; el.style.transform = 'none';
    });
    document.querySelectorAll('.hero__tag,.hero__sub,.hero__ctas,.hero__scene').forEach(function (el) {
      el.style.opacity = '1'; el.style.transform = 'none';
    });
    document.querySelectorAll('.hero__line span,.mf__word span').forEach(function (el) {
      el.style.transform = 'none';
    });
    return;
  }

  /* -----------------------------------------------
     GSAP ANIMATIONS
  ----------------------------------------------- */
  gsap.registerPlugin(ScrollTrigger);

  /* 1. HERO ENTRANCE TIMELINE */
  var heroSection = document.querySelector('.hero');
  if (heroSection) {
    var heroTag   = heroSection.querySelector('.hero__tag');
    var heroLines = heroSection.querySelectorAll('.hero__line');
    var heroSpans = heroSection.querySelectorAll('.hero__line span');
    var heroSub   = heroSection.querySelector('.hero__sub');
    var heroCtas  = heroSection.querySelector('.hero__ctas');
    var heroScene = heroSection.querySelector('.hero__scene');

    var tl = gsap.timeline({ delay: .2 });
    if (heroTag)   tl.to(heroTag,   { opacity: 1, y: 0, duration: .7, ease: 'power3.out' });
    if (heroLines.length) {
      tl.set(heroLines, { opacity: 1 }, '<');
      tl.fromTo(heroSpans, { y: '110%' }, { y: '0%', duration: .85, stagger: .12, ease: 'power4.out' }, '<');
    }
    if (heroSub)   tl.to(heroSub,   { opacity: 1, y: 0, duration: .8, ease: 'power3.out' }, '-=.35');
    if (heroCtas)  tl.to(heroCtas,  { opacity: 1, y: 0, duration: .75, ease: 'power3.out' }, '-=.5');
    if (heroScene) tl.to(heroScene, { opacity: 1, duration: 1.1, ease: 'power3.out' }, '-=.6');
  }

  /* 2. MANIFESTO WORD REVEAL */
  var mfSection = document.querySelector('.mf');
  if (mfSection) {
    var mfSpans = mfSection.querySelectorAll('.mf__word span');
    if (mfSpans.length) {
      ScrollTrigger.create({
        trigger: mfSection, start: 'top 72%', once: true,
        onEnter: function () {
          gsap.fromTo(mfSpans,
            { y: '120%' },
            { y: '0%', stagger: .18, duration: 1.1, ease: 'power4.out' }
          );
        }
      });
    }
    /* Manifesto parallax bg text */
    var mfBg = mfSection.querySelector('.mf__bg');
    if (mfBg) {
      gsap.to(mfBg, {
        x: '-20%',
        scrollTrigger: { trigger: mfSection, start: 'top bottom', end: 'bottom top', scrub: 2.5 }
      });
    }
  }

  /* 3. HERO GLOW PARALLAX */
  var glowR = document.querySelector('.hero__glow-r');
  if (glowR) {
    gsap.to(glowR, {
      y: -120,
      scrollTrigger: { trigger: heroSection || glowR, start: 'top top', end: 'bottom top', scrub: 2 }
    });
  }

  /* 4. GENERIC SCROLL REVEALS */
  gsap.utils.toArray('.rv').forEach(function (el) {
    gsap.fromTo(el,
      { opacity: 0, y: 44 },
      { opacity: 1, y: 0, duration: .9, ease: 'power3.out',
        scrollTrigger: { trigger: el, start: 'top 87%', once: true } }
    );
  });
  gsap.utils.toArray('.rvl').forEach(function (el) {
    gsap.fromTo(el,
      { opacity: 0, x: -44 },
      { opacity: 1, x: 0, duration: .9, ease: 'power3.out',
        scrollTrigger: { trigger: el, start: 'top 87%', once: true } }
    );
  });
  gsap.utils.toArray('.rvr').forEach(function (el) {
    gsap.fromTo(el,
      { opacity: 0, x: 44 },
      { opacity: 1, x: 0, duration: .9, ease: 'power3.out',
        scrollTrigger: { trigger: el, start: 'top 87%', once: true } }
    );
  });
  gsap.utils.toArray('.rvs').forEach(function (el) {
    gsap.fromTo(el,
      { opacity: 0, scale: .93 },
      { opacity: 1, scale: 1, duration: 1.1, ease: 'back.out(1.7)',
        scrollTrigger: { trigger: el, start: 'top 87%', once: true } }
    );
  });

  /* 5. HORIZONTAL ACTIVITY SCROLL — desktop only */
  var actSec   = document.getElementById('act-sec');
  var actTrack = document.getElementById('act-track');
  if (actSec && actTrack && window.innerWidth > 989) {
    var dist = actTrack.scrollWidth - window.innerWidth;
    if (dist > 0) {
      gsap.to(actTrack, {
        x: -dist, ease: 'none',
        scrollTrigger: {
          trigger: actSec, start: 'top top',
          end: function () { return '+=' + (dist + window.innerWidth * .5); },
          pin: true, scrub: 1.3, anticipatePin: 1
        }
      });
    }
  }

  /* 6. PRODUCT GRID STAGGER */
  document.querySelectorAll('.prod-grid, .pv-grid').forEach(function (grid) {
    var cards = grid.querySelectorAll('.pc, .pv-card');
    if (!cards.length) return;
    gsap.fromTo(cards,
      { opacity: 0, y: 40 },
      {
        opacity: 1, y: 0, duration: .7, ease: 'power2.out',
        stagger: { amount: .4, from: 'start' },
        scrollTrigger: { trigger: grid, start: 'top 82%', once: true }
      }
    );
  });

  /* 7. STATS SECTION ENTRANCE */
  var statsSection = document.querySelector('.stats');
  if (statsSection) {
    var stats = statsSection.querySelectorAll('.stat');
    if (stats.length) {
      gsap.fromTo(stats,
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: .7, ease: 'power3.out', stagger: .1,
          scrollTrigger: { trigger: statsSection, start: 'top 85%', once: true } }
      );
    }
  }

  /* Refresh after layout paint */
  ScrollTrigger.refresh();

})();
